import { StyleSheet } from 'react-native'
import colors from '../../../../../../constants/colors'
import sizes from '../../../../../../constants/sizes'
import { useHighlightColor, useSecondaryBackground } from '../../../../../../hooks/useColors'
import { Themes } from '../../../../../../types/dashbar/theme'
import { useTheme } from '../../../../../../utils/types/theme'

const useStyles = () => {
  const theme = useTheme()
  return StyleSheet.create({
    wrapper: {
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      //backgroundColor: theme === Themes.Dark ? colors.darkBgTransparent1 : colors.lightBgTransparent1,
      backgroundColor: useSecondaryBackground(),
      borderRadius: 15,
    },
    titleWrapper: {
      height: 170,
      maxHeight: 170,
      minHeight: 170,
      width: '100%',
      backgroundColor: 'orange',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 30,
    },
    backgroundFree: {
      backgroundColor: colors.bundleFree,
    },
    backgroundBusiness: {
      backgroundColor: colors.bundleBusiness,
    },
    backgroundPro: {
      backgroundColor: colors.bundlePro,
    },
    contentWrapper: {
      height: 170,
      maxHeight: 170,
      width: '100%',
    },
    contentAreaWrapper: {
      height: 85,
      maxHeight: 85,
      width: '100%',
      paddingHorizontal: 30,
      paddingVertical: 10,
      flex: 1,
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'space-around',
    },
    itemWrapper: {
      width: '50%',
      maxWidth: '50%',
      minWidth: '50%',
      flex: 1,
      flexDirection: 'row',
      alignContent: 'center',
      justifyContent: 'flex-start',
    },
    amountWrapper: {
      width: '50%',
      maxWidth: '50%',
      minWidth: '50%',
      flex: 1,
      flexDirection: 'column',
      alignContent: 'center',
      justifyContent: 'flex-start',
    },
    amountText: {
      marginVertical: 5,
    },
    buttonWrapper: {
      width: '50%',
      maxWidth: '50%',
      minWidth: '50%',
      flex: 1,
      flexDirection: 'column',
      alignContent: 'center',
      justifyContent: 'center',
      alignItems: 'flex-end',
    },
    button: {
      backgroundColor: useHighlightColor(),
      width: '100%',
      borderRadius: 10,
      color: 'white',
      height: sizes.buttonHeight,
    },
    itemText: {
      marginHorizontal: 15,
    },
    title: {
      fontSize: 30,
      fontWeight: '500',
      marginVertical: 15,
      color: 'white',
    },
    divider: {
      width: '100%',
      backgroundColor: theme === Themes.Dark ? colors.lightBg1 : colors.darkBg1,
      height: 1,
      maxHeight: 1,
    },
  })
}

export default useStyles
